/* eslint-disable */
const LangShare = {
	_sign_up: ["Sign Up", "បង្កើត​គណនី"],
	_login: ["Sign In", "ចូល​គណនី"],
	_sign_in: ["Sign In", "ចូល​គណនី"],
	_Submitting: ["Submitting...", "vi_Submitting..."],
	_Submit: ["Submit", "បញ្ជូន​"],
	_Cancel: ["Cancel", "បោះបង់"],
	_enableEdit: ["Edit", "កែប្រែ"],
	_Continue: ["Continue", "បន្តទៅ​មុខ"],
	_saveChanges: ["Save Change", "រក្សា​ទុក​ការ​កែប្រែ"],
	_unregister: ["Unregister", "លុប​គណនី"],
	_Reset: ["Reset", "vi_Reset"],
	_Back: ["Back", "ត្រឡប់​ក្រោយ"],
	_Reload: ["Reload", "បញ្ចូល​ទឹក​ប្រាក់"],
	_confirmAddress: ["Confirm Address", "បញ្ជាក់​អាសយដ្ឋាន"],

	_btnResetPassword: ["Reset My Password", "កំណត់​លេខ​​សម្ងាត់​ខ្ញុំ​ឡើង​វិញ"],
	_changeMyPassword: ["Change my Password", "ប្តូរ​លេខ​សម្ងាត់​ខ្ញុំ"],
	_currencyBalance: ["${currency} ${balance}", "${currency} ${balance}"],
	_Transfer: ["Transfer Balance", "ផ្ទេរ​ទឹក​ប្រាក់"],
	_SetAsDefault: ["Set as Default Card", "កំណត់​ជា​កាត​ចម្បង"],
	"_shared.form._cardNoRules": [
		"No spaces or dashes",
		"មិន​អនុញ្ញាតឲ្យ​​​ ដក​ឃ្លា ​ឬ​មាន​​សញ្ញា​​ដក",
	],
	"_shared.form._fileUploadRules": [
		"Accepted FileFormats: *.jpeg, *.jpg, *.gif, *.png, *.pdf",
		"ទទួល​​​ឯកសារ​​​ទម្រង់ជា *.jpeg, *.jpg, *.gif, *.png, *.pdf",
	],
	"_shared.form._cardDetails": ["CARD DETAILS", "ព័ត៌មាន​លម្អិត​​កាត"],
	"_shared.form.label._firstName": ["First Name", "គោត្តនាម"],
	"_shared.form.label._lastName": ["Last Name", "នាម"],
	"_shared.form.label._countryCode": [" ", " "],
	"_shared.form.label._mobileNo": ["Phone Number", "លេខ​ទូរស័ព្ទ"],
	"_shared.form.label._dob": ["Birthday", "ថ្ងៃ​ខែ​កំណើត"],
	"_shared.form.label._day": ["Day", "ថ្ងៃ"],
	"_shared.form.label._month": ["Month", "ខែ"],
	"_shared.form.label._year": ["Year", "vi_Year"],
	"_shared.form.label._password": ["Password", "លេខ​សម្ងាត់"],
	"_shared.form.label._confirmPassword": ["Confirm Password", "បញ្ជាក់​លេខ​សម្ងាត់"],
	"_shared.form.label._email": ["Email Address", "អាសយដ្ឋាន​អ៊ីម៉ែល"],
	"_shared.form.label._keepSignIn": ["Keep me sign in", "បន្ត​នៅ​ក្នុង​គណនី"],
	"_shared.form.label._card": ["Card", "កាត"],
	"_shared.form.label._cardNo": ["Card Number", "លេខ​កាត"],
	"_shared.form.label._printedName": ["Card Name", "ឈ្មោះ​កាត"],
	"_shared.form.label._securityCode": ["Security Code", "លេខ​កូដ​សុវត្ថិភាព"],
	"_shared.form.label._topic": ["Topic", "ប្រធាន​បទ"],
	"_shared.form.label._message": ["Message", "សារ"],
	"_shared.form.label._attachment": ["Attachment", "ឯកសារ​ភ្ជាប់"],
	"_shared.form.label._salutation": ["Salutation", "ពាក្យ​សម្គាល់​ងារ​"],
	"_shared.form.label._address": ["Address", "អាសយដ្ឋាន​"],
	"_shared.form.label._ward": ["Sangkat / Commune", "សង្កាត់ឃុំ"],
	"_shared.form.label._city": ["City / Province", "ខេត្ត​ក្រុង"],
	"_shared.form.label._district": ["Khan / District", "ខណ្ឌស្រុក"],
	"_shared.form.label._recaptcha": ["Captcha", "Captcha"],
	"_shared.form.info._contactCCCtoChangeFieldValue": [
		"This information is mandatory and cannot be changed, please contact our Customer Care for any queries at 023 986 591",
		"ព័ត៌មាន​​នេះ​ ​តម្រូវ​ឲ្យ​បំពេញ និង​មិន​អាច​ផ្លាស់​ប្តូរ​បាន​ទេ​ ។ សូម​ទាក់ទង​ផ្នែក​បម្រើ​សេវា​អតិថិជន​សម្រាប់​ ចម្ងល់​ផ្សេង​ៗ​តាម​ទូរស័ព្ទ​លេខ 023 986 591 ។",
	],
	"_shared.form.placeholder._select": ["Select", "ជ្រើសរើស"],
	"_shared.form.label._emailormobile": ["Email or phone number", "អ៊ីមែល ឬលេខទូរស័ព្ទ	"],
}

export default LangShare



// WEBPACK FOOTER //
// ./src/resources/general/LangShare.js